import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-16">
      <h1 className="display text-5xl md:text-7xl">FAQ</h1>
      <p className="text-neutral-400 text-sm mt-2">Pertanyaan yang sering ditanyakan.</p>
      <div className="mt-10 border-t border-[color:var(--border)]">
        {faqs.length === 0 ? <div className="py-8 text-neutral-500 text-sm">Belum ada FAQ.</div> : (
          <Accordion type="single" collapsible>
            {faqs.map((f) => (
              <AccordionItem key={f.id} value={f.id}>
                <AccordionTrigger className="text-left display text-2xl">{f.question}</AccordionTrigger>
                <AccordionContent className="text-neutral-300 text-sm whitespace-pre-line">{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        )}
      </div>
    </div>
  );
}
